export const SERVICE_TYPE_MANAGER_CONTRACT_ADDRESS = '0x9EfB0f4F38aFbb4b0984D00C126E97E21b8417C5';
//# sourceMappingURL=constants.js.map